let slugify = (string = '') => {
  if (string === null) {
    return ''
  }
  return string
    .toString()
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '')
}

let objIsEmpty = (obj) => {
  return JSON.stringify(obj) === JSON.stringify({})
}

let isValidLatitude = (lat) => {
  if (lat === '') {
    return false
  }
  return isFinite(lat) && Math.abs(lat) <= 90
}

let isValidLongitude = (lng) => {
  if (lng === '') {
    return false
  }
  return isFinite(lng) && Math.abs(lng) <= 180
}

let scrollToTopOfPage = () => {
  document.body.scrollTop = document.documentElement.scrollTop = 0
}

let getUrlParameterByName = (name, url) => {
  if (!url) url = window.location.href
  name = name.replace(/[\[\]]/g, "\\$&")
  let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)")
  let results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, " "))
}

let moveCursorToEnd = (el) => {
    if (typeof el.selectionStart == "number") {
        el.selectionStart = el.selectionEnd = el.value.length;
    } else if (typeof el.createTextRange != "undefined") {
        el.focus();
        var range = el.createTextRange();
        range.collapse(false);
        range.select();
    }
}

let formatDuration  = (seconds = 0) => {
    // let seconds = parseInt(seconds, 10); // don't forget the second param
    let hours   = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds - (hours * 3600)) / 60);
    // let seconds = seconds - (hours * 3600) - (minutes * 60);

    let output = ''
    if (hours > 0) {
      output += hours + ' hours '
    }
    if (minutes > 0) {
      output += minutes + ' mins'
    } else {
      output = '< 1 min'
    }
    return output

    // if (hours   < 10) {hours   = "0"+hours;}
    // if (minutes < 10) {minutes = "0"+minutes;}
    // if (seconds < 10) {seconds = "0"+seconds;}
}

// check an object against an array or property names, if property does not exist or is null/undefined/zero or empty string returns false
let objHasValidProps = (obj = {}, propArr = []) => {
  let result = true;
  propArr.forEach(x => {
    if (!!!obj[x]) { // !! is the same as Boolean(expression), if it is just a test if property exists then use hasOwnProperty
      result = false;
    }
  });
  return result;
}

// remove duplicate from an array of objects based on a property
let removeDuplicates = (myArr, prop) => {
  return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
  });
}

export default {
  slugify, objIsEmpty, isValidLatitude, isValidLongitude, scrollToTopOfPage, getUrlParameterByName, moveCursorToEnd, formatDuration, objHasValidProps, removeDuplicates
}



// WEBPACK FOOTER //
// ./src/helpers/utils.js